import styled from "styled-components";
import { palette } from "styled-theme";

const AppWrapper = styled.div`
  ion-content::part(background) {
    background: #f4f5f8;
  }
  .stick_to_top {
    background: #f4f5f8;
  }
  .tabs-inner {
    height: 100%;
    width: 100%;
  }
  ion-range {
    direction: ltr;
  }
  ion-item::part(detail-icon) {
    transform: ${(props) =>
      props["direction"] === "rtl" ? `rotate(180deg)` : "inherit"};
  }
  ion-icon::part(icon) {
    transform: ${(props) =>
      props["direction"] === "rtl" ? `rotate(180deg)` : "inherit"};
  }
  ion-back-button::part(icon) {
    transform: ${(props) =>
      props["direction"] === "rtl" ? `rotate(180deg)` : "inherit"};
  }
  ion-modal.month-picker-modal::part(content) {
    width: 75%;
    height: 300px;
    border-radius: 10px;
  }
  ion-modal.month-picker-modal ion-content::part(background) {
    background: #ffffff;
  }
  ion-modal.date-time-picker-modal::part(content) {
    width: 90%;
    height: 400px;
    border-radius: 10px;
  }
  ion-modal.date-time-picker-modal ion-content::part(background) {
    background: #ffffff;
  }

  ion-select::part(text) {
    white-space: unset;
    overflow: unset;
  }

  ion-badge {
    font-size: ${(props) => `${props["textSize"] * 13}px !important`};
  }

  ion-button,
  ion-list-header,
  label,
  span,
  ion-back-button {
    font-size: ${(props) => `${props["textSize"] * 14}px !important`};
  }

  ion-label,
  ion-select,
  ion-textarea,
  ion-item,
  .alert-radio-label,
  input,
  button,
  textarea,
  p {
    font-size: ${(props) => `${props["textSize"] * 16}px !important`};
  }

  ion-card-title,
  ion-title,
  h2 {
    font-size: ${(props) => `${props["textSize"] * 20}px !important`};
  }

  ion-tab-button ion-label {
    font-size: ${(props) =>
      props["textSize"] > 1.2
        ? `${1.2 * 13}px !important`
        : `${props["textSize"] * 13}px !important`};
  }

  .ios {
    --ion-safe-area-bottom: 20px;
    ion-toolbar {
      --padding-top: 10px;
    }
    ion-select::part(icon) {
      width: 18px;
    }
    ion-searchbar {
      padding-top: 0px;
      padding-bottom: 10px;
      height: 40px;
    }
  }
  .md {
    ion-modal.month-picker-modal::part(content) {
      width: 75%;
      height: 340px;
      border-radius: 10px;
    }

    ion-modal.date-time-picker-modal::part(content) {
      width: 90%;
      height: 490px;
      border-radius: 10px;
    }

    .label-stacked.sc-ion-label-md-h,
    .label-floating.sc-ion-label-md-h {
      transform-origin: ${(props) =>
        props["direction"] === "rtl" ? "top right" : "top left"};
    }
    .label-stacked.sc-ion-label-md-h {
      transform: ${(props) =>
        props["direction"] === "rtl"
          ? `translateY(35%) scale(0.75)`
          : `translateY(50%) scale(0.75)`};
    }
    ion-searchbar {
      padding-top: 0px;
    }
  }

  .branch_selector ion-item {
    --ion-background-color: transparent; // Or whatever color you want
  }
  .errors_container {
    padding: 0 20px;
    color: red;
  }
  ion-select::part(text) {
    color: #3880ff;
  }
  ion-select::part(icon) {
    color: #3880ff;
    opacity: 1;
  }
  .month-picker-button ion-button::part(native) {
    padding: 0;
  }

  ion-select::part(icon)[disabled] {
    display: none;
  }

  .select-disabled,
  .native-input:disabled,
  .item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-ios-h,
  .item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-md-h {
    opacity: 0.7 !important;
    color: #000000 !important;
    .select-icon {
      opacity: 0 !important;
    }
  }

  .select-interface .select-interface-option {
    height: auto !important;
    contain: unset;
    .alert-radio-label {
      white-space: break-spaces !important;
    }
  }

  .alert-wrapper.sc-ion-alert-md {
    max-width: calc(100vw - 40px);
    min-width: calc(100vw - 40px);
  }
  .alert-wrapper.sc-ion-alert-ios {
    max-width: calc(100vw - 60px);
  }
`;

export default AppWrapper;
